// import media files
import Avatar1 from 'assets/images/avatar/avatar-1.jpg';
import Avatar2 from 'assets/images/avatar/avatar-2.jpg';
import Avatar3 from 'assets/images/avatar/avatar-3.jpg';
import Avatar4 from 'assets/images/avatar/avatar-4.jpg';
import Avatar6 from 'assets/images/avatar/avatar-6.jpg';
import Avatar7 from 'assets/images/avatar/avatar-7.jpg';
import Avatar18 from 'assets/images/avatar/avatar-18.jpg';
import Avatar12 from 'assets/images/avatar/avatar-12.jpg';
import Avatar13 from 'assets/images/avatar/avatar-13.jpg';
import Avatar14 from 'assets/images/avatar/avatar-14.jpg';
import Avatar17 from 'assets/images/avatar/avatar-17.jpg';
import Avatar15 from 'assets/images/avatar/avatar-15.jpg';

export const QuizResultsData = [
	{
		id: 1,
		name: 'Reva Yokk',
		image: Avatar1,
		finishingTime: '20 July, 9:39am',
		score: 75,
		attempts: 2
	},
	{
		id: 2,
		name: 'Dianna Smiley',
		image: Avatar2,
		finishingTime: '20 July, 10:39am',
		score: 42,
		attempts: 4
	},
	{
		id: 3,
		name: 'Nia Sikhone',
		image: Avatar17,
		finishingTime: '20 July, 11:39am',
		score: 74,
		attempts: 5
	},
	{
		id: 4,
		name: 'Jacob Jones',
		image: Avatar14,
		finishingTime: '20 July, 09:39am',
		score: 32,
		attempts: 4
	},
	{
		id: 5,
		name: 'Kristin Watson',
		image: Avatar7,
		finishingTime: '19 July, 04:00am',
		score: 98,
		attempts: 3
	},
	{
		id: 6,
		name: 'Nia Sikhone',
		image: Avatar17,
		finishingTime: '19 July, 06:00am',
		score: 100,
		attempts: 3
	},
	{
		id: 7,
		name: 'Rivao Luke',
		image: Avatar17,
		finishingTime: '19 July, 12:00pm',
		score: 35,
		attempts: 2
	},
	{
		id: 8,
		name: 'Nia Sikhone',
		image: Avatar4,
		finishingTime: '18 July, 9:39am',
		score: 75,
		attempts: 4
	},
	{
		id: 9,
		name: 'Xiaon Merry',
		image: Avatar6,
		finishingTime: '18 July, 10:39am',
		score: 42,
		attempts: 2
	},
	{
		id: 10,
		name: 'Sina Ray',
		image: Avatar3,
		finishingTime: '18 July, 11:39am',
		score: 74,
		attempts: 3
	},
	{
		id: 11,
		name: 'Kristin Watson',
		image: Avatar15,
		finishingTime: '18 July, 09:39am',
		score: 32,
		attempts: 3
	},
	{
		id: 12,
		name: 'Jacob Jones',
		image: Avatar14,
		finishingTime: '17 July, 04:00am',
		score: 98,
		attempts: 1
	},
	{
		id: 13,
		name: 'Nia Sikhone',
		image: Avatar17,
		finishingTime: '17 July, 06:00am',
		score: 100,
		attempts: 1
	},
	{
		id: 14,
		name: 'Sina Ray',
		image: Avatar13,
		finishingTime: '17 July, 12:00pm',
		score: 35,
		attempts: 2
	},
	{
		id: 15,
		name: 'Reva Yokk',
		image: Avatar12,
		finishingTime: '16 July, 9:39am',
		score: 75,
		attempts: 3
	},
	{
		id: 16,
		name: 'Xiaon Merry',
		image: Avatar18,
		finishingTime: '16 July, 10:39am',
		score: 42,
		attempts: 2
	},
	{
		id: 17,
		name: 'Sina Ray',
		image: Avatar3,
		finishingTime: '16 July, 11:39am',
		score: 45,
		attempts: 5
	},
	{
		id: 18,
		name: 'Nia Sikhone',
		image: Avatar4,
		finishingTime: '16 July, 09:39am',
		score: 55,
		attempts: 2
	},
	{
		id: 19,
		name: 'Nia Sikhone',
		image: Avatar17,
		finishingTime: '15 July, 04:00am',
		score: 45,
		attempts: 5
	},
	{
		id: 20,
		name: 'Rivao Luke',
		image: Avatar17,
		finishingTime: '15 July, 06:00am',
		score: 74,
		attempts: 3
	}
];

export default QuizResultsData;
